import { ICommand } from 'core-ts-types';

export function MyResourceRoutes($stateProvider: any) {
  $stateProvider
    .state('my.resources', {
      url: 'resources/',
      template: '<my-resources/>',
      params: {
        childState: ''
      },
      sticky: true,
      data: {
        viewTitle: 'Resources',
        ignoredInHistory: true,
        preventResetFocus: true
      }
    })
    .state('my.resources.places', {
      url: 'places/',
      views: {
        'tab-content': {
          templateUrl: 'lib/my_resources/views/my_places_list/my_places_list.html',
          controller: 'MyPlacesListController',
          controllerAs: '$ctrl'
        }
      },
      params: {
        activeCategory: ''
      },
      data: {
        viewTitle: 'Resources | Places',
        ignoredInHistory: false
      },
      sticky: true,
      resolve: {
        categoryList: (loadResourceCategoriesCommand: ICommand) => {
          return loadResourceCategoriesCommand();
        }
      }
    })
    .state('my.resources.people', {
      url: 'people/',
      views: {
        'tab-content': {
          templateUrl: 'lib/my_resources/views/my_people_list/my_people_list.html',
          controller: 'MyPeopleListController',
          controllerAs: '$ctrl'
        }
      },
      params: {
        activeRelation: ''
      },
      data: {
        viewTitle: 'Resource | People',
        ignoredInHistory: false,
        preventResetFocus: true
      }
    })
    .state('my.resourcesDetail', {
      url: 'resources/detail/{id:int}',
      templateUrl: 'lib/my_resources/views/my_place_detail/my_place_detail.html',
      controller: 'MyPlaceDetailViewController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Resource Detail'
      },
      resolve: {
        resource: (loadResourceDetailCommand: ICommand, $stateParams: ng.ui.IStateParamsService) => {
          return loadResourceDetailCommand($stateParams.id);
        }
      }
    })
    .state('my.contactDetail', {
      url: 'contact-detail/:relationship/:contactId',
      templateUrl: 'lib/my_resources/views/my_people_detail/my_people_detail.html',
      controller: 'MyPeopleDetailViewController',
      controllerAs: '$ctrl',
      data: {
        viewTitle: 'Connection Detail'
      },
      sticky: true
    });
}



// WEBPACK FOOTER //
// ./app/lib/my_resources/resources_routes.ts